
export default {
  components: {
  },
  props: {
    attachmentInfo: {
      type: Array,
      default: []
    }
  },
  methods: {
    downloadFile(url) {
      window.open(url);
    }
  }
};
